// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSitesRouteImport } from './routes/admin/sites'
import { Route as AdminPaymentsRouteImport } from './routes/admin/payments'
import { Route as AdminFirmwareRouteImport } from './routes/admin/firmware'
import { Route as AdminDevicesRouteImport } from './routes/admin/devices'
import { Route as AdminConfigsRouteImport } from './routes/admin/configs'
import { Route as AdminAuditLogsRouteImport } from './routes/admin/audit-logs'

const NoAccessRoute = NoAccessRouteImport.update({
            id: '/no-access',path: '/no-access',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminSitesRoute = AdminSitesRouteImport.update({
            id: '/sites',path: '/sites',getParentRoute: () => AdminRoute
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AdminRoute
          })
const AdminFirmwareRoute = AdminFirmwareRouteImport.update({
            id: '/firmware',path: '/firmware',getParentRoute: () => AdminRoute
          })
const AdminDevicesRoute = AdminDevicesRouteImport.update({
            id: '/devices',path: '/devices',getParentRoute: () => AdminRoute
          })
const AdminConfigsRoute = AdminConfigsRouteImport.update({
            id: '/configs',path: '/configs',getParentRoute: () => AdminRoute
          })
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
            id: '/audit-logs',path: '/audit-logs',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAuditLogsRoute: AdminAuditLogsRoute,AdminConfigsRoute: AdminConfigsRoute,AdminDevicesRoute: AdminDevicesRoute,AdminFirmwareRoute: AdminFirmwareRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminSitesRoute: AdminSitesRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,LoginRoute: LoginRoute,NoAccessRoute: NoAccessRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)